import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { cards } from 'sections/DigitalTools/TrackingSystem/data';
import Card from 'components/Card';
import styles from 'sections/DigitalTools/TrackingSystem/components/SectionExperience/SectionExperience.module.scss';

const cn = classNames.bind(styles);

const SectionExperience = (): ReactElement => {
  const cardItems = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/DigitalTools/TrackingSystem/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('experience')}>
      <div className={cn('container')}>
        <div className={cn('experience__background-image-box')}>
          <img
            src="/images/pages/DigitalTools/TrackingSystem/bg-cloud-02.png"
            alt="Gradien background"
          />
        </div>
        <div className={cn('experience__phone-image-box')}>
          <img
            src="/images/pages/DigitalTools/TrackingSystem/phone.svg"
            alt="Shipment Tracking System Dashboard"
          />
        </div>
        <div className={cn('experience__content')}>
          <div className={cn('experience__title')}>
            Best online experience <br /> for your customers
          </div>
          <div className={cn('experience__cards')}>
            {cardItems}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionExperience;